/* VENUS - משחקי נובמבר לנשים (2026-11-01, עותק של ng-games.js עם מפתח שמירה נפרד וקונפטי בצבעי הנשים): גלגל > קופסאות > חשיפה. */
(function () {
  var root = document.getElementById('ng');
  if (!root) return;

  var KEY = 'venus_ng_women_v1';
  var $ = function (id) { return document.getElementById(id); };
  var store = {
    get: function () { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
    set: function (v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  };
  if (/[?&]ng=reset/.test(location.search)) { try { localStorage.removeItem(KEY); } catch (e) {} }

  var count = parseInt(root.dataset.count, 10) || 8;
  var win = Math.max(0, Math.min(count - 1, parseInt(root.dataset.win, 10) || 0));
  var step = 360 / count;
  var buzz = function (p) { try { navigator.vibrate && navigator.vibrate(p); } catch (e) {} };

  // ---- סאונד אפקטים (2026-10-29): Web Audio. הקבצים נטענים מראש, הצליל נפתח בנגיעה הראשונה ----
  var sfx = (function () {
    var urls = {}; try { urls = JSON.parse(root.dataset.sfx || '{}'); } catch (e) {}
    var AC = window.AudioContext || window.webkitAudioContext, ctx = null, bufs = {}, muted = false;
    try { muted = localStorage.getItem('venus_ng_mute') === '1'; } catch (e) {}
    if (AC) {
      try { ctx = new AC(); } catch (e) { ctx = null; }
      if (ctx) Object.keys(urls).forEach(function (k) {
        fetch(urls[k]).then(function (r) { return r.arrayBuffer(); }).then(function (a) {
          ctx.decodeAudioData(a, function (b) { bufs[k] = b; }, function () {});
        }).catch(function () {});
      });
    }
    function unlock() {
      if (!ctx || ctx.state !== 'suspended') return;
      try { ctx.resume(); var s = ctx.createBufferSource(); s.buffer = ctx.createBuffer(1, 1, 22050); s.connect(ctx.destination); s.start(0); } catch (e) {}
    }
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { document.addEventListener(ev, unlock, { passive: true, capture: true }); });
    // play(שם, עוצמה, השהיה בשניות, מאיזו נקודה בקובץ)
    function play(k, vol, delay, from) {
      if (muted || !ctx || !bufs[k]) return;
      try {
        var s = ctx.createBufferSource(), g = ctx.createGain();
        s.buffer = bufs[k]; g.gain.value = vol == null ? .6 : vol;
        s.connect(g); g.connect(ctx.destination);
        s.start(ctx.currentTime + (delay || 0), from || 0);
      } catch (e) {}
    }
    // טיק קצר של המחוג, מסונתז (בלי קובץ)
    function tick(vol) {
      if (muted || !ctx || ctx.state !== 'running') return;
      try {
        var t = ctx.currentTime, o = ctx.createOscillator(), g = ctx.createGain();
        o.type = 'triangle'; o.frequency.setValueAtTime(1500, t); o.frequency.exponentialRampToValueAtTime(600, t + .04);
        g.gain.setValueAtTime(vol || .25, t); g.gain.exponentialRampToValueAtTime(.001, t + .05);
        o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t + .06);
      } catch (e) {}
    }
    // סדק: רעש קצר וחד + נקישה נמוכה, מסונתז (בלי קובץ)
    function crack(vol) {
      if (muted || !ctx || ctx.state !== 'running') return;
      try {
        var t = ctx.currentTime, len = Math.floor(ctx.sampleRate * .12), b = ctx.createBuffer(1, len, ctx.sampleRate), d = b.getChannelData(0);
        for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3);
        var n = ctx.createBufferSource(), f = ctx.createBiquadFilter(), g = ctx.createGain();
        n.buffer = b; f.type = 'highpass'; f.frequency.value = 1400; g.gain.value = vol || .5;
        n.connect(f); f.connect(g); g.connect(ctx.destination); n.start(t);
        var o = ctx.createOscillator(), og = ctx.createGain();
        o.frequency.setValueAtTime(140, t); o.frequency.exponentialRampToValueAtTime(50, t + .1);
        og.gain.setValueAtTime((vol || .5) * .9, t); og.gain.exponentialRampToValueAtTime(.001, t + .12);
        o.connect(og); og.connect(ctx.destination); o.start(t); o.stop(t + .14);
      } catch (e) {}
    }
    var btn = $('ng-sound');
    function paint() { if (btn) { btn.setAttribute('aria-pressed', muted ? 'true' : 'false'); btn.setAttribute('aria-label', muted ? 'הפעלת הסאונד' : 'השתקת הסאונד'); } }
    if (btn) btn.addEventListener('click', function () {
      muted = !muted; paint();
      try { localStorage.setItem('venus_ng_mute', muted ? '1' : '0'); } catch (e) {}
      if (!muted) play('pop', .4);
    });
    paint();
    return { play: play, tick: tick, crack: crack };
  })();

  // ---- כפתור המימוש: מעביר הלאה את פרמטרי הקמפיין (utm וכו') ----
  var claim = $('ng-claim');
  if (claim && location.search) {
    var q = new URLSearchParams(location.search);
    q.delete('ng');
    var u = new URL(claim.getAttribute('href'), location.origin);
    q.forEach(function (val, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, val); });
    claim.setAttribute('href', u.pathname + u.search);
  }

  // ---- ציור הגלגל ----
  var R = 97, h = step / 2 * Math.PI / 180;
  var pt = function (a, r) { return [(r * Math.sin(a)).toFixed(2), (-r * Math.cos(a)).toFixed(2)]; };
  var segs = root.querySelectorAll('.ng-seg'), labels = [];
  segs.forEach(function (g, i) {
    var a = pt(-h, R), b = pt(h, R);
    g.querySelector('path').setAttribute('d', 'M0,0 L' + a[0] + ',' + a[1] + ' A' + R + ',' + R + ' 0 0 1 ' + b[0] + ',' + b[1] + ' Z');
    var center = i * step + step / 2;
    g.setAttribute('transform', 'rotate(' + center + ')');
    // תווית ישרה (אופקית) בשתי שורות, שנשארת ישרה גם בזמן הסיבוב
    var t = g.querySelector('text'), words = t.textContent.trim().split(/\s+/);
    var cut = Math.ceil(words.length / 2), lines = words.length > 2 ? words : words.length > 1 ? [words.slice(0, cut).join(' '), words.slice(cut).join(' ')] : words;
    // כל שורה היא <text> נפרד עם y משלה (ב-tspan עם x/dy, ספארי באייפון מערבב את השורות בעברית)
    var lab = document.createElementNS('http://www.w3.org/2000/svg', 'g'), fs = 10.5, lh = 1.15 * fs;
    t.parentNode.insertBefore(lab, t);
    lines.forEach(function (l, n) {
      var tx = t.cloneNode(false);
      tx.setAttribute('x', '0');
      tx.setAttribute('y', ((n - (lines.length - 1) / 2) * lh + 0.35 * fs).toFixed(2));
      // מספר + ₪ (כמו 20₪): כיוון משמאל לימין, כדי שה-₪ יישאר אחרי המספר
      tx.textContent = /\d/.test(l) && l.indexOf('₪') > -1 ? '\u202A' + l + '\u202C' : l;
      lab.appendChild(tx);
    });
    t.parentNode.removeChild(t); t = lab;
    labels.push({ el: t, center: center });
  });
  function uprightLabels(wheelAngle) {
    labels.forEach(function (L) {
      L.el.setAttribute('transform', 'translate(0,-60) rotate(' + (-(L.center + wheelAngle)).toFixed(2) + ')');
    });
  }
  uprightLabels(0);
  var dotsG = root.querySelector('.ng-wheel__dots'), dots = [];
  if (dotsG) {
    for (var d = 0; d < 24; d++) {
      var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      var p = pt(d / 24 * Math.PI * 2, 93.5);
      c.setAttribute('cx', p[0]); c.setAttribute('cy', p[1]); c.setAttribute('r', '1.9');
      dotsG.appendChild(c); dots.push(c);
    }
  }
  var dotTick = 0, dotTimer = setInterval(function () {
    dotTick++;
    dots.forEach(function (c, i) { c.classList.toggle('on', (i + dotTick) % 2 === 0); });
  }, 450);

  // ---- קונפטי ----
  function confetti(n) {
    var box = $('ng-confetti'); if (!box) return;
    var colors = ['#c63a7c', '#ffffff', '#fbeef4', '#e43b84', '#d9b26f', '#9b5fc0'];
    for (var i = 0; i < n; i++) {
      var el = document.createElement('i');
      el.style.left = (Math.random() * 100) + 'vw';
      el.style.background = colors[i % colors.length];
      el.style.setProperty('--x', (Math.random() * 160 - 80) + 'px');
      el.style.setProperty('--r', (Math.random() * 900 - 450) + 'deg');
      el.style.animationDuration = (2.2 + Math.random() * 1.8) + 's';
      el.style.animationDelay = (Math.random() * .35) + 's';
      if (Math.random() > .5) { el.style.width = '7px'; el.style.height = '7px'; el.style.borderRadius = '50%'; }
      box.appendChild(el);
      setTimeout(function (x) { return function () { x.remove(); }; }(el), 4800);
    }
  }

  function swap(from, to, cb) {
    if (from) {
      from.classList.add('is-leaving');
      setTimeout(function () { from.hidden = true; from.classList.remove('is-leaving'); show(); }, 430);
    } else show();
    function show() {
      if (!to) return cb && cb();
      to.hidden = false; to.classList.add('is-entering');
      setTimeout(function () { to.classList.remove('is-entering'); }, 700);
      cb && cb();
    }
  }
  var sub = $('ng-sub');
  var setSub = function (t) { if (sub && t) sub.textContent = t; };

  // ---- שלב 1: סיבוב ----
  var wheel = $('ng-wheel'), spinBtn = $('ng-spin'), pointer = root.querySelector('.ng-pointer');
  var spinning = false;
  function currentAngle() {
    var m = getComputedStyle(wheel).transform;
    if (!m || m === 'none') return 0;
    var v = m.match(/matrix\(([^)]+)\)/); if (!v) return 0;
    var p = v[1].split(',').map(parseFloat);
    var a = Math.atan2(p[1], p[0]) * 180 / Math.PI;
    return (a + 360) % 360;
  }
  function spin() {
    if (spinning) return;
    spinning = true; spinBtn.disabled = true;
    var center = win * step + step / 2;
    var jitter = (Math.random() * 0.6 - 0.3) * step;
    var target = 360 * 7 + (360 - center) + jitter;
    wheel.classList.add('is-spinning');
    sfx.play('whoosh', .55);
    requestAnimationFrame(function () { wheel.style.transform = 'rotate(' + target + 'deg)'; });

    // טיקים של המחוג בכל מעבר בין פלחים
    var last = -1, ticking = true;
    (function loop() {
      if (!ticking) return;
      var ang = currentAngle();
      uprightLabels(ang);
      var seg = Math.floor(((360 - ang) % 360) / step);
      if (seg !== last) {
        last = seg;
        if (pointer) { pointer.classList.remove('is-tick'); void pointer.offsetWidth; pointer.classList.add('is-tick'); }
        sfx.tick(.22);
      }
      requestAnimationFrame(loop);
    })();

    var done = false;
    function finish() {
      if (done) return; done = true; ticking = false;
      uprightLabels(target % 360);
      store.set('spun');
      var g = segs[win]; if (g) g.classList.add('is-winner');
      buzz([40, 60, 40]);
      sfx.play('win', .7);
      confetti(70);
      setTimeout(function () { swap(null, $('ng-win')); sfx.play('pop', .5); }, 900);
    }
    wheel.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 6600);
  }
  if (spinBtn) spinBtn.addEventListener('click', spin);

  // ---- מעבר לקופסאות ----
  function toBoxes(instant) {
    var w = $('ng-win'); if (w) w.hidden = true;
    setSub(root.dataset.boxSub || 'בחרי קופסה אחת. המתנה מחכה בפנים');
    if (instant) { $('ng-wheel-stage').hidden = true; $('ng-box-stage').hidden = false; return; }
    swap($('ng-wheel-stage'), $('ng-box-stage'), function () {
      setTimeout(function () { $('ng-box-stage').scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 120);
    });
  }
  var toBoxesBtn = $('ng-to-boxes');
  if (toBoxesBtn) toBoxesBtn.addEventListener('click', function () { sfx.play('whoosh', .45); toBoxes(false); });

  // ---- שלב 2: פתיחת קופסה (2026-10-29): נסדקת לאט, אור בורח מהסדקים, פיצוץ לרסיסים והבושם יוצא ----
  // סדקים שיוצאים ממרכז אחד לשולי הקופסה (במערכת 0-100). s = באיזה שלב הסדק נפתח
  var CRK = { c: [52, 44], rays: [
    { m: [41, 27], e: [30, 0], s: 1 }, { m: [65, 25], e: [78, 0], s: 2 }, { m: [79, 41], e: [100, 34], s: 1 },
    { m: [77, 64], e: [100, 82], s: 3 }, { m: [61, 73], e: [70, 100], s: 2 }, { m: [43, 69], e: [24, 100], s: 1 },
    { m: [27, 57], e: [0, 72], s: 3 }, { m: [25, 35], e: [0, 18], s: 2 }
  ], corners: { 1: [100, 0], 3: [100, 100], 5: [0, 100], 7: [0, 0] } };
  function buildCracks(box) {
    var body = box.querySelector('.ng-box__body'), C = CRK.c, NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'ng-cracks'); svg.setAttribute('viewBox', '0 0 100 100'); svg.setAttribute('preserveAspectRatio', 'none');
    var shards = document.createElement('span'); shards.className = 'ng-box__shards';
    CRK.rays.forEach(function (r, i) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', 'M' + C + ' L' + r.m + ' L' + r.e); p.setAttribute('pathLength', '1'); p.setAttribute('class', 's' + r.s);
      svg.appendChild(p);
      // סדק משני קטן מהאמצע של הסדק
      var q = document.createElementNS(NS, 'path'), bx = r.m[0] + (r.e[1] - r.m[1]) * .25, by = r.m[1] - (r.e[0] - r.m[0]) * .25;
      q.setAttribute('d', 'M' + r.m + ' L' + bx.toFixed(1) + ',' + by.toFixed(1)); q.setAttribute('pathLength', '1');
      q.setAttribute('class', 'b s' + Math.min(3, r.s + 1)); svg.appendChild(q);
      // רסיס: מהמרכז, לאורך הסדק הזה, דרך הפינה, וחזרה לאורך הסדק הבא
      var n = CRK.rays[(i + 1) % CRK.rays.length], pts = [C, r.m, r.e];
      if (CRK.corners[i]) pts.push(CRK.corners[i]);
      pts.push(n.e, n.m);
      var sh = document.createElement('i'); sh.className = 'ng-box__shard';
      sh.style.clipPath = 'polygon(' + pts.map(function (q) { return q[0] + '% ' + q[1] + '%'; }).join(',') + ')';
      var cx = 0, cy = 0; pts.forEach(function (q) { cx += q[0]; cy += q[1]; }); cx = cx / pts.length - C[0]; cy = cy / pts.length - C[1];
      var len = Math.sqrt(cx * cx + cy * cy) || 1, dist = 110 + Math.random() * 90;
      sh.style.setProperty('--tx', (cx / len * dist).toFixed(0) + 'px');
      sh.style.setProperty('--ty', (cy / len * dist - 40).toFixed(0) + 'px');
      sh.style.setProperty('--rot', ((Math.random() * 2 - 1) * 160).toFixed(0) + 'deg');
      shards.appendChild(sh);
    });
    body.appendChild(svg);
    box.appendChild(shards);
  }

  var boxes = $('ng-boxes'), opened = false;
  if (boxes) boxes.addEventListener('click', function (e) {
    var box = e.target.closest('.ng-box');
    if (!box || opened) return;
    opened = true;
    var cr = boxes.getBoundingClientRect(), br = box.getBoundingClientRect();
    box.style.setProperty('--dx', ((cr.left + cr.width / 2) - (br.left + br.width / 2)) + 'px');
    boxes.classList.add('is-choosing');
    boxes.querySelectorAll('.ng-box').forEach(function (b) { b.classList.add(b === box ? 'is-picked' : 'is-dim'); });
    buildCracks(box);
    buzz(20);
    var T = 2.7; // רגע הפיצוץ, בשניות מהבחירה
    sfx.play('pop', .55);
    sfx.play('riser', .5, 0, Math.max(0, 2.87 - T)); // השיא של הרייזר נוחת בדיוק בפיצוץ
    sfx.play('boom', .8, T - .29);
    sfx.play('win', .6, T - .24);
    setTimeout(function () { box.classList.add('c1', 'is-glow'); sfx.crack(.45); buzz(15); }, 850);
    setTimeout(function () { box.classList.add('c2'); sfx.crack(.6); buzz([15, 40, 15]); }, 1500);
    setTimeout(function () { box.classList.add('c3'); sfx.crack(.75); buzz([20, 30, 20, 30, 20]); }, 2100);
    setTimeout(function () { box.classList.add('c4'); sfx.crack(.5); }, 2450);
    setTimeout(function () {
      box.classList.add('is-burst');
      boxes.classList.add('is-burst');
      var f = document.createElement('div'); f.className = 'ng-flash'; document.body.appendChild(f);
      setTimeout(function () { f.remove(); }, 800);
      root.classList.add('ng-shake-screen');
      setTimeout(function () { root.classList.remove('ng-shake-screen'); }, 400);
      buzz([60, 40, 120]);
      confetti(160);
      store.set('opened');
    }, T * 1000);
    // ההצעה עולה מהר אחרי שהבושם יוצא
    setTimeout(function () { toReveal(false); }, T * 1000 + 950);
  });

  // ---- שלב 3: חשיפה ----
  function toReveal(instant) {
    setSub(root.dataset.revealSub || '');
    var head = root.querySelector('.ng-head');
    if (instant) {
      $('ng-wheel-stage').hidden = true; $('ng-box-stage').hidden = true; $('ng-reveal').hidden = false;
      if (head) head.hidden = true;
      return;
    }
    if (head) head.hidden = true;
    sfx.play('chime', .55);
    swap($('ng-box-stage'), $('ng-reveal'), function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ---- פתיח (גל, 2026-10-30): נשאר עד שהפונטים והדף נטענו (לפחות 1.8 שנ', לכל היותר 4), ואז הגלגל מסתובב פנימה ----
  (function () {
    var intro = $('ng-intro'); if (!intro) { root.classList.remove('is-intro'); return; }
    var MIN = 1800, MAX = 4000, t0 = 0, done = false;
    var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    var loaded = new Promise(function (r) { if (document.readyState === 'complete') r(); else window.addEventListener('load', r, { once: true }); });
    function finish() {
      if (done) return; done = true;
      intro.classList.add('is-out');
      root.classList.remove('is-intro');
      root.classList.add('ng-enter');
      sfx.play('whoosh', .5);
      setTimeout(function () { intro.remove(); }, 1000);
      setTimeout(function () { root.classList.remove('ng-enter'); }, 2600);
    }
    Promise.all([fontsReady, loaded]).then(function () {
      var now = (window.performance && performance.now) ? performance.now() : MIN;
      setTimeout(finish, Math.max(0, MIN - (now - t0)));
    });
    setTimeout(finish, MAX);
  })();

  // ---- חזרה לדף: ממשיכים מאיפה שעצרו ----
  var state = store.get();
  if (state === 'opened') { clearInterval(dotTimer); toReveal(true); }
  else if (state === 'spun') { toBoxes(true); }
})();
